<template lang="pug">
  el-dropdown(
    trigger='click',
    @visible-change="dropdownClose"
  )
    el-tooltip(
      effect='dark',
      content='Pesquisa Geral',
      placement="bottom"
    )
      i.fal.fa-search.icone
    el-dropdown-menu.drop-down-menu(slot='dropdown')
      .drop-down-text
        strong Pesquisa rápida
        label
          span.drop-down-text Buscar pelo número de processo ou nome do interessado
          filtro(
            @pesquisar="pesquisarAppGeral",
            @limpar="limparPesquisaGeral",
            :configuracaoFiltro="configuracaoFiltro",
            :showPesquisaAvancada="false",
            placeholder="",
            :limparCampo="limparCampo",
            :campoSimplesObrigatorio="true",
            :pesquisaGeral="true",
            :naoInicializarInformacoesCaixa="true"
          )
        span.encontrados(v-if="totalElements > 0 && jaPesquisou") {{totalElements}} - processos encontrados!
        span.encontrados(v-if="totalElements === 0 && jaPesquisou") Nenhum processo encontrado.
      el-dropdown-item.drop-down-item(v-if='processos' v-for='(processo, index) in processos', :key='processo.id')
        .processo(@click="irParaCaixaDoProcesso(processo.caixa, processo.numeroProcesso)")
          div
            span Nome/Razão social do interessado:
              strong {{processo.nomeRazaoSocialInteressado}}
          div
            span CPF/CNPJ do interessado:
              strong {{processo.cpfCnpjInteressado}}
          div
            span Situação:
              strong {{processo.status}}
      .footer(v-if='processos.length > 1')
        .load(v-if='totalElements > 15 && totalElements !== processos.length')
          a(
            @click='maisProcessos',
            v-if='!isLoading'
          ) carregar mais
          i.el-icon-loading(v-else)
        .resposta-footer(v-else)
          span(v-if="totalElements <= 15 && jaPesquisou") Não há mais processos
          span(v-else-if="jaPesquisou") Não há processos

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Filtro from '@/components/Filtro'
import FILTRO_EMPTY from '@/models/filtro'
const BaseFiltro = require('@/screens/analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default

export default {
  components: {
    Filtro
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      pesquisa: '',
      limparCampo: false,
      filtro: FILTRO_EMPTY('PESQUISA_GERAL'),
      configuracaoFiltro: {},
      processos: [],
      isLoading: false,
      showCarregarMais: false,
      jaPesquisou: false
    }
  },

  methods: {
    ...mapActions({
      findNotificacoes: 'notificacao/findNotificacoes',
      atualizarNumeroProcessoPesquisaGeral: 'filtroPesquisaGeral/atualizarNumeroProcessoPesquisaGeral'
    }),

    irParaCaixaDoProcesso (caixa, numeroProcesso) {
      if (this.$route.name !== caixa) {
        this.atualizarNumeroProcessoPesquisaGeral(numeroProcesso)
        this.$router.push({ name: caixa })
      }
      this.atualizarNumeroProcessoPesquisaGeral(numeroProcesso)
    },

    dropdownClose (visible) {
      this.jaPesquisou = false
      this.limparCampo = false
      this.totalElements = 0
      if (!visible) {
        this.limparProcessos()
      }
    },

    limparProcessos () {
      this.limparCampo = true
      this.processos = []
      this.pagina = 0
    },

    pesquisarAppGeral (filtro) {
      this.pesquisaGeral(filtro)
      this.jaPesquisou = true
      this.verificaQuantiaProcessos()
    },

    verificaQuantiaProcessos () {
      if (this.totalElements > 15) {
        this.showCarregarMais = true
      } else {
        this.showCarregarMais = false
      }
    },

    maisProcessos () {
      this.isLoading = true
      this.pagina++
      this.pesquisarAppGeral(this.filtro)
      this.isLoading = false
    },

    limparPesquisaGeral () {
      this.processos = []
      this.totalElements = 0
      this.jaPesquisou = false
    }
  },

  computed: {
    ...mapGetters({
      numeroProcessoPesquisaGeral: 'filtroPesquisaGeral/getNumeroProcessoPesquisaGeral'
    })
  }
}
</script>

<style lang="scss">
.drop-down-menu {
  padding: 15px;
  max-height: 400px;
  width: 480px !important;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f5f5f5;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.drop-down-item {
  background-color: #fff;
  margin: 5px 0;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.drop-down-item:hover {
  background-color: #e0e0e0;
}

.drop-down-text {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 5px;
}

.text label {
  margin: 20px 0 10px 0;
}

.drop-down-text {
  position: relative;
  bottom: -14px ;
}

.processo {
  margin-top: 15px;
  display: flex;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  height: 80px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
}

.processo div {
  display: flex;
  flex-wrap: wrap;
  margin: 0px !important;
  padding: 0 !important;
}

.processo span {
  font-size: 15px;
  color: #333;
  margin: 2px !important;
  padding: 0 !important;
  line-height: 1.1;
}

.processo strong::before {
  content: ' ';
}

.processo strong {
  font-size: 15px;
  margin: 0 !important;
  padding: 0 !important;
}

.el-dropdown-item .processo div {
  margin: 0 !important;
  padding: 0 !important;
}

.icone {
  font-size: 20px;
}

.footer {
  font-size: 13px;
  display: flex;
  text-align: center;
  padding-top: 10px;

  .load {
    width: 100%;
  }

  a {
    cursor: pointer;
  }

  a:hover {
    color: #009f61;
  }

  .resposta-footer {
    width: 100%;
  }
}

.encontrados {
  margin-bottom: 2px;
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppPesquisaGeral.vue